import styled from 'styled-components';
import { flexbox } from '../../styles/helpers/flexbox';

const Link = styled.a`
  text-decoration: underline;
  padding-left: 5px;
`;

const ContentText = styled.p`
  padding: 8px;
`;

const Footer = styled.div(() => `
    ${flexbox()};
    margin: auto;

    .btnOk {
      margin: 15px auto 0;
      padding: 6px 30px;
    }
`);

export { ContentText, Link, Footer };
